import { Components, Theme } from '@mui/material'
import alertTheme from './alert'
import button from './button'
import { chip, dialog, formLabel, menu, skeleton, slider, tablePagination, tooltip } from './misc'
import { inputLabel, outlinedInput, select, textField } from './input'

const components: Components<Theme> = {
  MuiTablePagination: tablePagination,
  MuiFormLabel: formLabel,
  MuiSkeleton: skeleton,
  MuiInputLabel: inputLabel,
  MuiTextField: textField,
  MuiSelect: select,
  MuiOutlinedInput: outlinedInput,
  MuiAlert: alertTheme(),
  MuiChip: chip,
  MuiButton: button,
  MuiDialog: dialog,
  MuiMenu: menu,
  MuiTooltip: tooltip,
  MuiSlider: slider
}

export default components
